<template>
    <div class="uxo-types columns is-multiline justify-content-center">
        <div v-if="false" class="column d-flex">
            <a href="/explosive-hazards" class="uxo-type__landmines card card--with-padding mb-1">
                <img class="uxo-type__landmines__image image mb-2" src="/img/uxo-svg/all.svg" alt="All UXO" />
                <h5 class="font-weight-normal mb-1">All UXO</h5>
            </a>
        </div>
        <div class="column d-flex">
            <a href="/explosive-hazards/landmines" class="uxo-type__landmines card card--with-padding mb-1">
                <img class="uxo-type__landmines__image image mb-2" src="/img/uxo-svg/landmines.svg" alt="Landmine" />
                <h5 class="font-weight-normal mb-1">Landmines</h5>
            </a>
        </div>
        <div class="column d-flex">
            <a href="/explosive-hazards/submunitions" class="uxo-type__submunitions card card--with-padding mb-1">
                <img class="uxo-type__submunitions__image image mb-2" src="/img/uxo-svg/submunitions.svg" alt="Submunitions" />
                <h5 class="font-weight-normal mb-1">Submunitions</h5>
            </a>
        </div>
        <div class="column d-flex">
            <a href="/explosive-hazards/grenades" class="uxo-type__grenades card card--with-padding mb-1">
                <img class="uxo-type__grenades__image image mb-2" src="/img/uxo-svg/grenades.svg" alt="Grenades" />
                <h5 class="font-weight-normal mb-1">Grenades</h5>
            </a>
        </div>
        <div class="column d-flex">
            <a href="/explosive-hazards/aircraft-bombs" class="uxo-type__aircraft-bombs card card--with-padding mb-1">
                <img class="uxo-type__aircraft-bombs__image image mb-2" src="/img/uxo-svg/aircraft-bombs.svg" alt="Aircraft Bombs" />
                <h5 class="font-weight-normal mb-1">Aircraft Bombs</h5>
            </a>
        </div>
        <div class="column d-flex">
            <a href="/explosive-hazards/rockets" class="uxo-type__rockets card card--with-padding mb-1">
                <img class="uxo-type__rockets__image image pt-4px mb-2" src="/img/uxo-svg/rockets.svg" alt="Rockets" />
                <h5 class="font-weight-normal mb-1">Rockets</h5>
            </a>
        </div>
        <div class="column d-flex">
            <a href="/explosive-hazards/missiles" class="uxo-type__missiles card card--with-padding mb-1">
                <img class="uxo-type__missiles__image image mb-2" src="/img/uxo-svg/missiles.svg" alt="Missiles" />
                <h5 class="font-weight-normal mb-1">Missiles</h5>
            </a>
        </div>
        <div class="column d-flex">
            <a href="/explosive-hazards/mortars" class="uxo-type__mortars card card--with-padding mb-1">
                <img class="uxo-type__mortars__image image mb-2" src="/img/uxo-svg/mortars.svg" alt="Mortars" />
                <h5 class="font-weight-normal mb-1">Mortars</h5>
            </a>
        </div>
        <div class="column d-flex">
            <a href="/explosive-hazards/projectiles" class="uxo-type__projectiles card card--with-padding mb-1">
                <img class="uxo-type__projectiles__image image mb-2" src="/img/uxo-svg/projectiles.svg" alt="Projectiles" />
                <h5 class="font-weight-normal mb-1">Projectiles</h5>
            </a>
        </div>
        <div class="column d-flex">
            <a href="/explosive-hazards/firing-devices" class="uxo-type__firing-devices card card--with-padding mb-1">
                <img class="uxo-type__firing-devices__image image pt-4px mb-2" src="/img/uxo-svg/firing-devices.svg" alt="Firing Devices" />
                <h5 class="font-weight-normal mb-1">Firing Devices</h5>
            </a>
        </div>
        <div class="column d-flex">
            <a href="/explosive-hazards/fuzes" class="uxo-type__fuzes card card--with-padding mb-1">
                <img class="uxo-type__fuzes__image image mb-2" src="/img/uxo-svg/fuzes.svg" alt="Fuzes" />
                <h5 class="font-weight-normal mb-1">Fuzes</h5>
            </a>
        </div>

        <div class="column d-flex">
            <a href="/explosive-hazards/naval-devices" class="uxo-type__fuzes card card--with-padding mb-1">
                <img class="uxo-type__fuzes__image image mb-2" src="/img/uxo-svg/naval-devices.svg" alt="Fuzes" />
                <h5 class="font-weight-normal mb-1">Naval Devices</h5>
            </a>
        </div>
        <div class="column d-flex">
            <a href="/explosive-hazards/salw" class="uxo-type__fuzes card card--with-padding mb-1">
                <img class="uxo-type__fuzes__image image mb-2" src="/img/uxo-svg/salw.svg" alt="Fuzes" />
                <h5 class="font-weight-normal mb-1">SALW</h5>
            </a>
        </div>
        <div class="column d-flex">
            <a href="/explosive-hazards/ucav" class="uxo-type__fuzes card card--with-padding mb-1">
                <img class="uxo-type__fuzes__image image mb-2" src="/img/uxo-svg/ucav.svg" alt="Fuzes" />
                <h5 class="font-weight-normal mb-1">UCAV</h5>
            </a>
        </div>
        <div class="column d-flex">
            <a href="/explosive-hazards/afv" class="uxo-type__fuzes card card--with-padding mb-1">
                <img class="uxo-type__fuzes__image image mb-2" src="/img/uxo-svg/afv.svg" alt="Fuzes" />
                <h5 class="font-weight-normal mb-1">AFV</h5>
            </a>
        </div>
        <div class="column d-flex">
            <a href="/explosive-hazards/misc" class="uxo-type__fuzes card card--with-padding mb-1">
                <img class="uxo-type__fuzes__image image mb-2" src="/img/uxo-svg/misc.svg" alt="Fuzes" />
                <h5 class="font-weight-normal mb-1">Misc</h5>
            </a>
        </div>

        <div class="column d-flex">
            <a href="/explosive-hazards/ied" class="uxo-type__projectiles card card--with-padding mb-1">
                <img class="uxo-type__projectiles__image image mb-2" src="/img/uxo/ied.png" alt="Projectiles" />
                <h5 class="font-weight-normal mb-1">IEDs</h5>
            </a>
        </div>
        <div class="column d-flex">
            <a href="/explosive-hazards/incidents" class="uxo-type__firing-devices card card--with-padding mb-1">
                <img class="uxo-type__firing-devices__image image pt-4px mb-2" src="/img/uxo/incidents.png" alt="Firing Devices" />
                <h5 class="font-weight-normal mb-1">IED Incidents</h5>
            </a>
        </div>
        <div class="column d-flex">
            <a href="/explosive-hazards/terrorist-groups" class="uxo-type__fuzes card card--with-padding mb-1">
                <img class="uxo-type__fuzes__image image mb-2 mt-2" src="/img/uxo/terrorist-groups.png" alt="Fuzes" />
                <h5 class="font-weight-normal mb-1">Terrorist Groups</h5>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CatUxoTypes"
    }
</script>

<style lang="scss" scoped>
    .uxo-types {

        &.columns {
            display: flex;
        }

        .column {
            -ms-flex-preferred-size: initial;
            flex-basis: initial;
        }

        @include media-breakpoint-down(md) {
            .column {
                max-width: rem(256px);
                padding: rem(8px 12px);
            }
        }

        .card {
            text-align: center;
            min-width: rem(120px);
            justify-content: flex-end;
            align-items: center;
            width: 100%;

            h5 {
                font-size: rem(14px);
            }

            @media(min-width: 450px) {
                min-width: rem(156px);

                h5 {
                    font-size: rem(18px);
                }
            }

            @include media-breakpoint-up(sm) {
                min-width: rem(202px);
            }

            @include media-breakpoint-only(lg) {
                min-width: rem(192px);
            }

            @include media-breakpoint-down(xs) {
                padding: rem(8px 0);
            }
        }

        .image {
            width: auto;
        }
    }

    .uxo-type {
        &__landmines__image {
            max-height: rem(60px);
        }

        &__submunitions__image {
            max-height: rem(60px);
        }

        &__grenades__image {
            max-height: rem(60px);
        }

        &__aircraft-bombs__image {
            max-height: rem(60px);
        }

        &__rockets__image {
            max-height: rem(60px);
        }

        &__missiles__image {
            max-height: rem(60px);
        }

        &__mortars__image {
            max-height: rem(60px);
        }

        &__projectiles__image {
            max-height: rem(60px);
        }

        &__firing-devices__image {
            max-height: rem(60px);
        }

        &__fuzes__image {
            max-height: rem(60px);
        }
    }
    @media (max-width: 532px) {
        .uxo-types{
            padding: 0 4px;
        }
    }

</style>



// WEBPACK FOOTER //
// resources/js/components/uxo/Types.vue